/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CopyOrgKeyMaterialBody
} from './model/copyOrgKeyMaterialBody.js';

import type {
  ErrorEnvelope
} from './model/errorEnvelope.js';

import type {
  ProvisionOrganizationRunloopAccount200
} from './model/provisionOrganizationRunloopAccount200.js';

import type {
  SetOrgSecretBody
} from './model/setOrgSecretBody.js';

import type {
  SetSandboxProviderBody
} from './model/setSandboxProviderBody.js';

import type {
  ValidateSandboxProviderBody
} from './model/validateSandboxProviderBody.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Mark the org's guided setup as complete.
 */
export const completeOrgBootstrap = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/bootstrap-complete`, method: 'POST', signal
    },
      options);
    }




export const getCompleteOrgBootstrapMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOrgBootstrap>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completeOrgBootstrap>>, TError,void, TContext> => {

const mutationKey = ['completeOrgBootstrap'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeOrgBootstrap>>, void> = () => {


          return  completeOrgBootstrap(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteOrgBootstrapMutationResult = NonNullable<Awaited<ReturnType<typeof completeOrgBootstrap>>>

    export type CompleteOrgBootstrapMutationError = unknown

    /**
 * @summary Mark the org's guided setup as complete.
 */
export const useCompleteOrgBootstrap = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeOrgBootstrap>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completeOrgBootstrap>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCompleteOrgBootstrapMutationOptions(options));
    }
    /**
 * The caller needs secrets access on both the source and target orgs.
 * @summary Copy sandbox and model provider keys from another org.
 */
export const copyOrgKeyMaterial = (
    copyOrgKeyMaterialBody: CopyOrgKeyMaterialBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/copy-key-material`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: copyOrgKeyMaterialBody, signal
    },
      options);
    }




export const getCopyOrgKeyMaterialMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyOrgKeyMaterial>>, TError,{data: CopyOrgKeyMaterialBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof copyOrgKeyMaterial>>, TError,{data: CopyOrgKeyMaterialBody}, TContext> => {

const mutationKey = ['copyOrgKeyMaterial'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof copyOrgKeyMaterial>>, {data: CopyOrgKeyMaterialBody}> = (props) => {
          const {data} = props ?? {};

          return  copyOrgKeyMaterial(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CopyOrgKeyMaterialMutationResult = NonNullable<Awaited<ReturnType<typeof copyOrgKeyMaterial>>>
    export type CopyOrgKeyMaterialMutationBody = CopyOrgKeyMaterialBody
    export type CopyOrgKeyMaterialMutationError = unknown

    /**
 * @summary Copy sandbox and model provider keys from another org.
 */
export const useCopyOrgKeyMaterial = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof copyOrgKeyMaterial>>, TError,{data: CopyOrgKeyMaterialBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof copyOrgKeyMaterial>>,
        TError,
        {data: CopyOrgKeyMaterialBody},
        TContext
      > => {
      return useMutation(getCopyOrgKeyMaterialMutationOptions(options));
    }
    /**
 * @summary Mark a plugin setup step as complete.
 */
export const completePluginSetupStep = (
    plugin: string,
    step: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/plugins/${encodeURIComponent(String(plugin))}/setup-steps/${encodeURIComponent(String(step))}/complete`, method: 'POST', signal
    },
      options);
    }




export const getCompletePluginSetupStepMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePluginSetupStep>>, TError,{plugin: string;step: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completePluginSetupStep>>, TError,{plugin: string;step: string}, TContext> => {

const mutationKey = ['completePluginSetupStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completePluginSetupStep>>, {plugin: string;step: string}> = (props) => {
          const {plugin,step} = props ?? {};

          return  completePluginSetupStep(plugin,step,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompletePluginSetupStepMutationResult = NonNullable<Awaited<ReturnType<typeof completePluginSetupStep>>>

    export type CompletePluginSetupStepMutationError = unknown

    /**
 * @summary Mark a plugin setup step as complete.
 */
export const useCompletePluginSetupStep = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePluginSetupStep>>, TError,{plugin: string;step: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completePluginSetupStep>>,
        TError,
        {plugin: string;step: string},
        TContext
      > => {
      return useMutation(getCompletePluginSetupStepMutationOptions(options));
    }
    /**
 * @summary Run a plugin setup step's connection test.
 */
export const testPluginSetupStep = (
    plugin: string,
    step: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/plugins/${encodeURIComponent(String(plugin))}/setup-steps/${encodeURIComponent(String(step))}/test`, method: 'POST', signal
    },
      options);
    }




export const getTestPluginSetupStepMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testPluginSetupStep>>, TError,{plugin: string;step: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof testPluginSetupStep>>, TError,{plugin: string;step: string}, TContext> => {

const mutationKey = ['testPluginSetupStep'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testPluginSetupStep>>, {plugin: string;step: string}> = (props) => {
          const {plugin,step} = props ?? {};

          return  testPluginSetupStep(plugin,step,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestPluginSetupStepMutationResult = NonNullable<Awaited<ReturnType<typeof testPluginSetupStep>>>

    export type TestPluginSetupStepMutationError = unknown

    /**
 * @summary Run a plugin setup step's connection test.
 */
export const useTestPluginSetupStep = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testPluginSetupStep>>, TError,{plugin: string;step: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof testPluginSetupStep>>,
        TError,
        {plugin: string;step: string},
        TContext
      > => {
      return useMutation(getTestPluginSetupStepMutationOptions(options));
    }
    /**
 * @summary List setup steps for the org's active plugins.
 */
export const listPluginSetupSteps = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/plugins/setup-steps`, method: 'GET', signal
    },
      options);
    }




export const getListPluginSetupStepsQueryKey = () => {
    return [
    `/org-setup/plugins/setup-steps`
    ] as const;
    }


export const getListPluginSetupStepsQueryOptions = <TData = Awaited<ReturnType<typeof listPluginSetupSteps>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginSetupSteps>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPluginSetupStepsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPluginSetupSteps>>> = ({ signal }) => listPluginSetupSteps(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPluginSetupSteps>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPluginSetupStepsQueryResult = NonNullable<Awaited<ReturnType<typeof listPluginSetupSteps>>>
export type ListPluginSetupStepsQueryError = unknown


/**
 * @summary List setup steps for the org's active plugins.
 */

export function useListPluginSetupSteps<TData = Awaited<ReturnType<typeof listPluginSetupSteps>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPluginSetupSteps>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPluginSetupStepsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Provision a Runloop account for an organization
 */
export const provisionOrganizationRunloopAccount = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ProvisionOrganizationRunloopAccount200>(
      {url: `/org-setup/runloop-provider/provision`, method: 'POST', signal
    },
      options);
    }




export const getProvisionOrganizationRunloopAccountMutationOptions = <TError = ErrorEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionOrganizationRunloopAccount>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof provisionOrganizationRunloopAccount>>, TError,void, TContext> => {

const mutationKey = ['provisionOrganizationRunloopAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof provisionOrganizationRunloopAccount>>, void> = () => {


          return  provisionOrganizationRunloopAccount(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProvisionOrganizationRunloopAccountMutationResult = NonNullable<Awaited<ReturnType<typeof provisionOrganizationRunloopAccount>>>

    export type ProvisionOrganizationRunloopAccountMutationError = ErrorEnvelope

    /**
 * @summary Provision a Runloop account for an organization
 */
export const useProvisionOrganizationRunloopAccount = <TError = ErrorEnvelope,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof provisionOrganizationRunloopAccount>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof provisionOrganizationRunloopAccount>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getProvisionOrganizationRunloopAccountMutationOptions(options));
    }
    /**
 * @summary Report the org's sandbox provider key and account.
 */
export const getSandboxProvider = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/sandbox-provider`, method: 'GET', signal
    },
      options);
    }




export const getGetSandboxProviderQueryKey = () => {
    return [
    `/org-setup/sandbox-provider`
    ] as const;
    }


export const getGetSandboxProviderQueryOptions = <TData = Awaited<ReturnType<typeof getSandboxProvider>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSandboxProvider>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSandboxProviderQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSandboxProvider>>> = ({ signal }) => getSandboxProvider(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSandboxProvider>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSandboxProviderQueryResult = NonNullable<Awaited<ReturnType<typeof getSandboxProvider>>>
export type GetSandboxProviderQueryError = unknown


/**
 * @summary Report the org's sandbox provider key and account.
 */

export function useGetSandboxProvider<TData = Awaited<ReturnType<typeof getSandboxProvider>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSandboxProvider>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSandboxProviderQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Validate and save the org's sandbox provider API key.
 */
export const setSandboxProvider = (
    setSandboxProviderBody: SetSandboxProviderBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/sandbox-provider`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setSandboxProviderBody, signal
    },
      options);
    }




export const getSetSandboxProviderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSandboxProvider>>, TError,{data: SetSandboxProviderBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setSandboxProvider>>, TError,{data: SetSandboxProviderBody}, TContext> => {

const mutationKey = ['setSandboxProvider'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSandboxProvider>>, {data: SetSandboxProviderBody}> = (props) => {
          const {data} = props ?? {};

          return  setSandboxProvider(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetSandboxProviderMutationResult = NonNullable<Awaited<ReturnType<typeof setSandboxProvider>>>
    export type SetSandboxProviderMutationBody = SetSandboxProviderBody
    export type SetSandboxProviderMutationError = unknown

    /**
 * @summary Validate and save the org's sandbox provider API key.
 */
export const useSetSandboxProvider = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSandboxProvider>>, TError,{data: SetSandboxProviderBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setSandboxProvider>>,
        TError,
        {data: SetSandboxProviderBody},
        TContext
      > => {
      return useMutation(getSetSandboxProviderMutationOptions(options));
    }
    /**
 * @summary Report whether the org's stored sandbox key works.
 */
export const getSandboxProviderHealth = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/sandbox-provider/health`, method: 'GET', signal
    },
      options);
    }




export const getGetSandboxProviderHealthQueryKey = () => {
    return [
    `/org-setup/sandbox-provider/health`
    ] as const;
    }


export const getGetSandboxProviderHealthQueryOptions = <TData = Awaited<ReturnType<typeof getSandboxProviderHealth>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSandboxProviderHealth>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSandboxProviderHealthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSandboxProviderHealth>>> = ({ signal }) => getSandboxProviderHealth(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSandboxProviderHealth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSandboxProviderHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getSandboxProviderHealth>>>
export type GetSandboxProviderHealthQueryError = unknown


/**
 * @summary Report whether the org's stored sandbox key works.
 */

export function useGetSandboxProviderHealth<TData = Awaited<ReturnType<typeof getSandboxProviderHealth>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSandboxProviderHealth>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSandboxProviderHealthQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Check a sandbox provider API key without saving it.
 */
export const validateSandboxProvider = (
    validateSandboxProviderBody: ValidateSandboxProviderBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/sandbox-provider/validate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: validateSandboxProviderBody, signal
    },
      options);
    }




export const getValidateSandboxProviderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateSandboxProvider>>, TError,{data: ValidateSandboxProviderBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof validateSandboxProvider>>, TError,{data: ValidateSandboxProviderBody}, TContext> => {

const mutationKey = ['validateSandboxProvider'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateSandboxProvider>>, {data: ValidateSandboxProviderBody}> = (props) => {
          const {data} = props ?? {};

          return  validateSandboxProvider(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ValidateSandboxProviderMutationResult = NonNullable<Awaited<ReturnType<typeof validateSandboxProvider>>>
    export type ValidateSandboxProviderMutationBody = ValidateSandboxProviderBody
    export type ValidateSandboxProviderMutationError = unknown

    /**
 * @summary Check a sandbox provider API key without saving it.
 */
export const useValidateSandboxProvider = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateSandboxProvider>>, TError,{data: ValidateSandboxProviderBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof validateSandboxProvider>>,
        TError,
        {data: ValidateSandboxProviderBody},
        TContext
      > => {
      return useMutation(getValidateSandboxProviderMutationOptions(options));
    }
    /**
 * @summary Save an org secret by name.
 */
export const setOrgSecret = (
    name: string,
    setOrgSecretBody: SetOrgSecretBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/secrets/${encodeURIComponent(String(name))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setOrgSecretBody, signal
    },
      options);
    }




export const getSetOrgSecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrgSecret>>, TError,{name: string;data: SetOrgSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setOrgSecret>>, TError,{name: string;data: SetOrgSecretBody}, TContext> => {

const mutationKey = ['setOrgSecret'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setOrgSecret>>, {name: string;data: SetOrgSecretBody}> = (props) => {
          const {name,data} = props ?? {};

          return  setOrgSecret(name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetOrgSecretMutationResult = NonNullable<Awaited<ReturnType<typeof setOrgSecret>>>
    export type SetOrgSecretMutationBody = SetOrgSecretBody
    export type SetOrgSecretMutationError = unknown

    /**
 * @summary Save an org secret by name.
 */
export const useSetOrgSecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setOrgSecret>>, TError,{name: string;data: SetOrgSecretBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setOrgSecret>>,
        TError,
        {name: string;data: SetOrgSecretBody},
        TContext
      > => {
      return useMutation(getSetOrgSecretMutationOptions(options));
    }
    /**
 * @summary Report which of the org's secrets are set.
 */
export const getOrgSecretsStatus = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/secrets/status`, method: 'GET', signal
    },
      options);
    }




export const getGetOrgSecretsStatusQueryKey = () => {
    return [
    `/org-setup/secrets/status`
    ] as const;
    }


export const getGetOrgSecretsStatusQueryOptions = <TData = Awaited<ReturnType<typeof getOrgSecretsStatus>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgSecretsStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgSecretsStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgSecretsStatus>>> = ({ signal }) => getOrgSecretsStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgSecretsStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgSecretsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgSecretsStatus>>>
export type GetOrgSecretsStatusQueryError = unknown


/**
 * @summary Report which of the org's secrets are set.
 */

export function useGetOrgSecretsStatus<TData = Awaited<ReturnType<typeof getOrgSecretsStatus>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgSecretsStatus>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgSecretsStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Report the org's guided setup progress.
 */
export const getOrgSetupState = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/org-setup/state`, method: 'GET', signal
    },
      options);
    }




export const getGetOrgSetupStateQueryKey = () => {
    return [
    `/org-setup/state`
    ] as const;
    }


export const getGetOrgSetupStateQueryOptions = <TData = Awaited<ReturnType<typeof getOrgSetupState>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgSetupState>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrgSetupStateQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgSetupState>>> = ({ signal }) => getOrgSetupState(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrgSetupState>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrgSetupStateQueryResult = NonNullable<Awaited<ReturnType<typeof getOrgSetupState>>>
export type GetOrgSetupStateQueryError = unknown


/**
 * @summary Report the org's guided setup progress.
 */

export function useGetOrgSetupState<TData = Awaited<ReturnType<typeof getOrgSetupState>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrgSetupState>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetOrgSetupStateQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






